import { analytics, performance } from "../../../firebase.ts";
import { trace, PerformanceTrace } from "firebase/performance";
import { logEvent, setUserProperties } from "firebase/analytics";
import template from "./sw-alert.mjs";

export class SwAlert extends HTMLElement {
    private componentTrace: PerformanceTrace;
    private timer: number = 0;
    private banner: HTMLElement;
    private info: HTMLElement;
    //private hide: HTMLElement;

    constructor() {
        super();
        this.componentTrace = trace(performance, "component");
        this.componentTrace.putAttribute("view", "sw-alert");
        this.componentTrace.start();
        this.appendChild(template.content.cloneNode(true));

        this.banner = this.querySelector("#sw-alert")!;
        this.info = this.querySelector("#sw-alert-info")!;
        //this.hide = this.querySelector("#sw-alert-hide")!;
    }

    connectedCallback() {
        this.addEventListener("click", (event: Event) => this.hideBanner(0));

        this.componentTrace.incrementMetric("count", 1);
        this.componentTrace.stop();
    }

    showBanner(info: string, reload: boolean = false) {
        this.info.textContent = info;
        clearTimeout(this.timer);
        this.timer = window.setTimeout(() => {
            this.banner.classList.remove("translate-y-full");
            this.hideBanner(10000, reload);
        }, 500);
    }

    // reload needed for the browser to clear the default cache for images
    private hideBanner(duration: number, reload: boolean = false) {
        clearTimeout(this.timer);
        this.timer = window.setTimeout(() => {
            if (reload) {
                window.location.reload();
            } else {
                this.banner.classList.add("translate-y-full");
            }
        }, duration);
        logEvent(analytics, "close", { banner: "bottom" });
    }
}
